export type PaymentDetailsRow = {
  transaction_id?: string | number;
  /** Reports table (`TransactionsTable`) returns the transaction id as `id`. */
  id?: string | number;
  user_id?: string;
  /**
   * Reports table (`TransactionsTable`) returns the user UUID in `player`
   * (column titled ID). Withdrawal-review / user-manager use `user_id`
   * instead. Prefer `user_id` when both are present.
   */
  player?: string;
  username?: string;
};

export type PaymentDetailsIds = {
  userId: string | null;
  transactionId: string | null;
};

/**
 * Normalize heterogeneous list/review rows into the ids the details
 * endpoint needs. Review-queue ids like `manual_review_<uuid>` are passed
 * through unchanged.
 *
 * Id aliases by source:
 * - User Manager / Withdrawal Review: `user_id` + `transaction_id`
 * - Reports (`TransactionsTable`): `player` (user UUID) + `id` (transaction)
 */
export function toPaymentDetailsIds(
  row: PaymentDetailsRow | null | undefined,
): PaymentDetailsIds {
  if (!row) {
    return { userId: null, transactionId: null };
  }

  const rawTransactionId = row.transaction_id ?? row.id;
  const transactionId =
    rawTransactionId != null && String(rawTransactionId).trim() !== ""
      ? String(rawTransactionId)
      : null;

  const rawUserId = row.user_id ?? row.player;
  const userId =
    rawUserId != null && String(rawUserId).trim() !== ""
      ? String(rawUserId)
      : null;

  return { userId, transactionId };
}
